<template>
    <div
        class="nav-actions"
        data-test="nav-actions">
        <SkyButton
            v-if="actions.searchUrl"
            :aria-label="
                intl.formatMessage({
                    defaultMessage: 'Search',
                    id: 'globals.search',
                })
            "
            :href="actions.searchUrl"
            :title="
                intl.formatMessage({
                    defaultMessage: 'Search',
                    id: 'globals.search',
                })
            "
            class="nav-actions__item nav-actions__item--first"
            data-test="nav-search"
            size="sm"
            variant="text">
            <template #iconRight="{ iconAttrs }">
                <SkyIconSearch
                    v-bind="iconAttrs"
                    decorative></SkyIconSearch>
            </template>
            <span class="nav-actions__label">{{
                intl.formatMessage({
                    defaultMessage: "Search",
                    id: "globals.search",
                })
            }}</span>
        </SkyButton>

        <div
            v-if="actions.searchUrl && actions.helpUrl"
            class="nav-actions__divider nav-actions__divider--help"
            data-test="nav-actions-divider">
        </div>

        <SkyButton
            v-if="actions.helpUrl"
            :aria-label="
                intl.formatMessage({
                    defaultMessage: 'Help',
                    id: 'globals.help',
                })
            "
            :href="actions.helpUrl"
            :title="
                intl.formatMessage({
                    defaultMessage: 'Help',
                    id: 'globals.help',
                })
            "
            class="nav-actions__item nav-actions__item--last nav-actions__item--help"
            data-test="nav-help"
            size="sm"
            variant="text">
            <template #iconRight="{ iconAttrs }">
                <SkyIconCircleQuestion
                    v-bind="iconAttrs"
                    decorative></SkyIconCircleQuestion>
            </template>
            <span class="nav-actions__label">{{
                intl.formatMessage({
                    defaultMessage: "Help",
                    id: "globals.help",
                })
            }}</span>
        </SkyButton>
    </div>
</template>

<script lang="ts">
    export interface IActionsConfig {
        searchUrl?: string | null;
        helpUrl?: string | null;
    }

    export interface INavActionsProps {
        actions: IActionsConfig;
    }
</script>

<script lang="ts" setup>
    import { injectI18n } from "@eg_ui/src/translations/i18n";

    import { SkyButton, SkyIconCircleQuestion, SkyIconSearch } from "@skyline2/vue";

    const { actions } = defineProps<INavActionsProps>();

    const intl = injectI18n();
</script>

<style lang="scss">
    @use "./NavActions.scss";
</style>
